import { SET_NOTIFICATION_SUMMARY } from "../helpers/vuex-constants";
import { mapActions } from "vuex";
import {
  MaxProjectionYear,
  ChartTypeDropDownValues,
  ChartViewDropDownValues,
} from "../helpers/constant";
export default {
  data() {
    return {
      projectionYear: {
        Value: 0,
        Maxvalue: MaxProjectionYear,
        IsError: false,
        ErrorText: [],
      },
      lastprojectionYear: 0,
      isShowEmptyState: false,
      pageHeadingInfo: {
        heading: "Enter and test superannuation details",
        headingIconText: " test hover",
        subHeading:
          "You can keep adjusting until you are happy with the outcome",
      },
      linkGoalInfo: {
        goalborder: "tertiary",
        goalTitle: "Related Goals",
        goalsectionName: "Link Related Goal",
      },
      emptyChartMessage: {
        message: "Complete Data Entry To View Graph",
      },
      leftToolSummary: [{ key: "Net CashFlow", value: "View Details" }],

      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          message: "You are about to discard the changes you have made.",
          title: "Discard Changes",
          leftButtons: [
            {
              text: "Keep Editing",
              variation: "secondary",
              emitevent: "backButtonDialogCancel_Click",
              id: 2,
            },
          ],
          rightButtons: [
            {
              text: "Discard",
              variation: "secondary",
              emitevent: "backButtonDialogDiscard_Click",
              id: 1,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "backButtonDialogSave_Click",
              id: 3,
            },
          ],
        },
        {
          toggle: false,
          message: "",
          title: "Save instance",
          id: 2,
          leftButtons: [
            {
              text: "Cancel",
              variation: "secondary",
              emitevent: "saveButtonDialogCancel_Click",
              id: 1,
            },
          ],
          rightButtons: [
            {
              text: "Save",
              variation: "secondary",
              emitevent: "saveButtonDialogSave_Click",
              id: 2,
            },
            {
              text: "Save as",
              variation: "primary",
              emitevent: "saveButtonDialogSaveAs_Click",
              id: 3,
            },
          ],
        },
        {
          toggle: false,
          id: 3,
          message: "You are about to discard the changes you have made.",
          title: "Discard Changes",
          leftButtons: [
            {
              text: "Keep Editing",
              variation: "secondary",
              emitevent: "backButtonDialogCancel_Click",
              id: 2,
            },
          ],
          rightButtons: [
            {
              text: "Discard",
              variation: "secondary",
              emitevent: "cancelButtonDialogDiscard_Click",
              id: 1,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "backButtonDialogSave_Click",
              id: 3,
            },
          ],
        },
      ],
    };
  },
  computed: {},
  methods: {
    onSelectDataTypeFilter(button, data) {
      button.toggle1 = false;
      this.buttonDataTypeConfig[0].listItems.forEach(
        (m) => (m.isActive = false)
      );
      data.isActive = true;
      button.text = "Chart: " + data.itemText;
      this.showTable = data.itemValue == 3;
    },
    setChartDataTypeDropDown() {
      let chartTypeDropDownValues = [];
      chartTypeDropDownValues = ChartTypeDropDownValues;
      chartTypeDropDownValues.filter(
        (m) => m.itemValue == 1
      )[0].isActive = true;
      this.buttonDataTypeConfig.push({
        text:
          "Chart: " +
          chartTypeDropDownValues.filter((m) => m.itemValue == 1)[0].itemText,
        listItems: [{}],
        filterType: 0,
      });

      this.buttonDataTypeConfig[0].listItems = chartTypeDropDownValues;
    },

    setChartViewTypeDropDown() {
      let chartViewDropDownValues = [];
      chartViewDropDownValues = ChartViewDropDownValues;
      let itemValue = this.showTableView ? 3 : 1;
      chartViewDropDownValues.filter(
        (m) => m.itemValue == itemValue
      )[0].isActive = true;
      chartViewDropDownValues.filter(
        (m) => m.itemValue != itemValue
      )[0].isActive = false;

      this.buttonViewTypeConfig.push({
        text:
          "View: " +
          chartViewDropDownValues
            .filter((m) => m.itemValue == itemValue)[0]
            .itemText.slice(0, -5),
        listItems: [{}],
        filterType: itemValue,
      });

      this.buttonViewTypeConfig[0].listItems = chartViewDropDownValues;
    },
    ResetGraphsModel() {
      this.RemapGraphsModel();
      this.resetLastEnteredValueInForm();
    },
    resetLastEnteredValueInForm() {
      let totalFields = this.formModel.elements.length;
      for (let i = 0; i < totalFields; i++) {
        this.formModel.elements[i].lastUserEnteredValue =
          this.formModel.elements[i].value;
      }
    },
    changeProjectionYear(value) {
      this.projectionYear.Value = value;

      this.validationsProjectionYear();
    },
    validationsProjectionYear() {
      if (
        this.projectionYear.Value <= 0 ||
        this.projectionYear.Value > MaxProjectionYear
      ) {
        this.projectionYear.IsError = true;
        this.projectionYear.ErrorText = ["Value should be greater than Zero."];

        return false;
      } else {
        this.projectionYear.IsError = false;

        return true;
      }
    },
    genericMethodClick(function_name, data, additionalInfo) {
      this[function_name](data, additionalInfo);
    },
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
    }),

    async saveEngagementData(apiResponse, message, url) {
      if (apiResponse && apiResponse.status == 200) {
        this.setNotificationSummary({
          isShow: true,
          variation: "success",
          text: message,
        });
      } else {
        this.setNotificationSummary({
          isShow: true,
          variation: "error",
          text: message,
        });
      }
      this.$router.push({ name: url });
    },
    mapTableView(headerColumn, Elements, Rows, FIrstHeader = "Year") {
      let headers = [];
      headers.push(FIrstHeader);
      Rows.forEach((element) => {
        headers.push(element[headerColumn]);
      });
      let tableData = {
        headers: headers,
        rows: Rows,
        Elements: Elements,
      };
      return tableData;
    },
  },
};
